import { helper } from '@ember/component/helper';

export default helper(function valueHelper([ index, count ]) {
  const max = count - 1;
  return max <= 0 ? 0 : index / max;
});
